<template>
  <div>
    <div class="conten">
      <el-row>
        <el-col :span="17">
          <div
            style="padding: 20px 50px;box-sizing: border-box;line-height: 20px;font-size:14px;"
          >
            <div>
              奖品设置
              <span style="color: red;font-size: 20px"
                >(奖品中必须存在一个谢谢参与选项!!!!)</span
              >
            </div>
            <el-divider></el-divider>
            <el-form ref="form" label-width="120px">
              <el-form-item label="奖品个数">
                <el-radio-group v-model="form.award_num" @change="award_num">
                  <el-radio :label="1">4个</el-radio>
                  <el-radio :label="2">6个</el-radio>
                  <el-radio :label="3">8个</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
          <div
            style="padding: 20px 50px;box-sizing: border-box;line-height: 20px;font-size:14px;"
          >
            <el-tabs v-model="activeName">
              <el-tab-pane
                v-for="(item, i) in form.awards"
                :key="i"
                :label="item.label"
                :name="String(i)"
                lazy
              >
                <transition name="fade">
                  <el-form ref="form" label-width="120px">
                    <el-form-item label="奖品名称">
                      <el-input
                        v-model="item.award_name"
                        placeholder="奖品名称"
                        style="width: 30%;"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="奖品概率">
                      <el-input
                        v-model="item.rate"
                        class="no-number"
                        placeholder="百分比"
                        style="width: 10%;"
                        type="number"
                        @input="Remaining_method(item.rate, i)"
                      ></el-input>
                      %
                      <span> 总概率100%,</span>
                      <span style="margin-left: 10px;"
                        >剩余<span style="color: #409EFF;">{{ Remaining }}</span
                        >%</span
                      >
                    </el-form-item>
                    <el-form-item label="奖品数量">
                      <el-input
                        v-model="item.stock"
                        class="no-number"
                        placeholder="整数"
                        style="width: 10%;"
                        type="number"
                        @blur="IFnum(item.stock,i)"
                      ></el-input>
                      <div style="font-size:12px;">
                        数量发放完将不再发放该奖品
                      </div>
                    </el-form-item>
                    <el-form-item label="奖品类型">
                      <el-radio-group
                        v-model="item.award_type"
                        @change="prize_type_method($event, item)"
                      >
                        <el-radio :label="1">优惠券</el-radio>
                        <el-radio :label="2">积分</el-radio>
                        <el-radio :label="3">实物</el-radio>
                        <el-radio :label="4">余额</el-radio>
                        <el-radio :label="5">谢谢参与</el-radio>
                      </el-radio-group>
                      <div
                        v-if="
                          item.award_type == 1 ||
                            item.award_type == 2 ||
                            item.award_type == 4
                        "
                        class="content_s"
                      >
                        <div v-if="item.award_type == 1">
                          <span>优惠券 </span>
                          <el-select
                            v-model="item.coupons"
                            collapse-tags
                            filterable
                            multiple
                            placeholder="请选择"
                            size="small"
                            style="margin-bottom: 10px;"
                            @change="coupons_select($event, item)"
                            @remove-tag="del_coupon($event, item)"
                          >
                            <el-option
                              v-for="items in options"
                              :key="items.id"
                              :label="items.title"
                              :value="items.id"
                            >
                            </el-option>
                          </el-select>
                          <span>
                            没有合适的优惠券?
                            <el-button
                              type="text"
                              @click="
                                $router.push(
                                  '/apply/newVip/13/market/marketing/salesPromotion/optionTicket'
                                )
                              "
                              >去创建</el-button
                            >
                          </span>
                          <el-table
                            :data="item.coupon_list"
                            empty-text="还没有选择优惠券"
                            style="width: 100%"
                          >
                            <el-table-column label="券名称" prop="title">
                            </el-table-column>
                            <!--                            <el-table-column label="券类型" prop="show_type">-->
                            <!--                            </el-table-column>-->
                            <el-table-column label="数量" prop="stock">
                              <template slot-scope="scope">
                                <el-input-number
                                  v-model="scope.row.coupon_num"
                                  size="small"
                                ></el-input-number>
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                        <div v-if="item.award_type == 2">
                          <el-input
                            v-model="item.integral"
                            class="no-number"
                            placeholder="整数"
                            size="small"
                            style="width: 15%;"
                            type="number"
                          ></el-input>
                          <span v-if="item.award_type == 2"> 积分</span>
                        </div>
                        <div v-if="item.award_type == 4">
                          <el-input
                            v-model="item.balance"
                            class="no-number"
                            placeholder="整数"
                            size="small"
                            style="width: 15%;"
                            type="number"
                          ></el-input>
                          <span> 元</span>
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="奖品图片">
                      <el-upload
                        :http-request="
                          file => {
                            return imgUpload(file, item);
                          }
                        "
                        :show-file-list="false"
                        action="#"
                        class="avatar-uploader"
                        list-type="picture-card"
                      >
                        <img
                          v-if="item.pic_url"
                          :src="item.pic_url"
                          class="avatar"
                        />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item v-if="item.award_type !== 5" label="高级选项">
                      <div>
                        <el-button
                          v-if="!item.isShow"
                          type="text"
                          @click="IsShow(item, 0)"
                          >查看
                        </el-button>
                        <el-button v-else type="text" @click="IsShow(item, 1)"
                          >收起
                        </el-button>
                      </div>

                      <div v-if="item.isShow" class="content_s">
                        <el-form ref="form">
                          <el-form-item label="指定中奖人手机号">
                            <div
                              v-for="(items, i) in item.user_mobile"
                              :key="i"
                            >
                              <div>
                                <el-input
                                  v-model="item.user_mobile[i]"
                                  placeholder="手机号(选填)"
                                  size="small"
                                  style="width: 40%;"
                                  type="text"
                                ></el-input>
                                <el-button
                                  type="text"
                                  @click="add_user_mobile(item)"
                                  >添加
                                </el-button>
                                <el-button
                                  type="text"
                                  @click="del_user_mobile(item, i)"
                                  >删除
                                </el-button>
                              </div>
                            </div>
                          </el-form-item>
                          <el-form-item label="中奖次数">
                            <span>每</span>
                            <el-input
                              v-model="item.phoneNumber"
                              class="no-number"
                              placeholder="整数(选填)"
                              size="small"
                              style="width: 20%;"
                              type="number"
                            ></el-input>
                            <span>天,可中</span>
                            <el-input
                              v-model="item.user_num"
                              class="no-number"
                              placeholder="整数(选填)"
                              size="small"
                              style="width: 20%;"
                              type="number"
                            ></el-input>
                            <span>次</span>
                          </el-form-item>
                          <el-form-item label="指定时间进入奖池">
                            <el-date-picker
                              v-model="item.user_time"
                              placeholder="日期(选填)"
                              size="small"
                              style="width: 40%;"
                              type="datetime"
                              value-format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                          </el-form-item>
                        </el-form>
                      </div>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="back"
                        >返回规则设置
                      </el-button>
                      <el-button
                        v-if="Number(activeName) < form.awards.length - 1"
                        @click="activeName = String(i + 1)"
                        >下一步
                      </el-button>
                      <el-button
                        v-if="Number(activeName) > 0"
                        @click="activeName = String(i - 1)"
                        >上一步
                      </el-button>
                      <el-button
                        v-if="form.award_num == 1 && activeName == '3'"
                        type="primary"
                        @click="onSubmit()"
                        >提交
                      </el-button>
                      <el-button
                        v-if="form.award_num == 2 && activeName == '5'"
                        type="primary"
                        @click="onSubmit()"
                        >提交
                      </el-button>
                      <el-button
                        v-if="form.award_num == 3 && activeName == '7'"
                        type="primary"
                        @click="onSubmit()"
                        >提交
                      </el-button>
                    </el-form-item>
                  </el-form>
                </transition>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import store from "@/store/index";
import { couponList } from "@/api/coupon";
import { addImage } from "@/api/mall";
import { lottery_edit, luck_draw } from "@/api/vip";
import { hideLoading, showLoading } from "@/utils/loading";
import time from "@/utils/time";

import { myFilter } from "@/utils/public";

export default {
  data() {
    return {
      form: {},
      coupons: [],
      Remainings: [0, 0, 0, 0, 0, 0, 0, 0],
      Remaining: 100,
      coupon_table: [],
      isShow: false,
      activeName: "0",
      crowd: 4,
      tabs: [],
      blocks: [{ padding: "10px", background: "#d64737" }],
      prizes: [],
      options: [],
      pic_url: ""
    };
  },
  watch: {
    crowd() {
      // debugger
    },
    tabs(val) {
      console.log("4567667", val);
    }
  },
  mounted() {
    this.getcouponList();
    this.form = store.getters.lotteryfrom;
    this.public(
      this.$route.query.key ? store.getters.lotteryfrom.awards.length : 4
    );
    if (this.$route.query.key) {
      this.form.awards.forEach((item, i) => {
        this.Remainings[i] = item.rate;
      });
    }
  },
  methods: {
    IFnum(e,i){
      if(e<0){
        this.form.awards[i].stock = 0
        this.$message('数量不能小于0')
      }
    },
    IsShow(item, key) {
      if (key == 1) {
        item.isShow = false;
      } else {
        item.isShow = true;
      }
      this.$forceUpdate();
    },
    award_num(val) {
      if (val == 1) {
        this.crowd = 4;
        if (this.form.awards.length == 6) {
          this.form.awards.splice(this.form.awards.length - 2, 2);
        }
        if (this.form.awards.length == 8) {
          this.form.awards.splice(this.form.awards.length - 4, 4);
        }
      } else if (val == 2) {
        this.crowd = 6;
        if (this.form.awards.length == 4) {
          if (this.$route.query.key) {
            this.public(2, "edit");
          } else {
            this.public(2);
          }
        }
        if (this.form.awards.length == 8) {
          this.form.awards.splice(this.form.awards.length - 2, 2);
        }
      } else {
        this.crowd = 8;
        if (this.form.awards.length == 4) {
          if (this.$route.query.key) {
            this.public(4, "edit");
          } else {
            this.public(4);
          }
        }
        if (this.form.awards.length == 6) {
          if (this.$route.query.key) {
            this.public(2, "edit");
          } else {
            this.public(2);
          }
        }
      }
    },
    //添加中奖人手机号
    add_user_mobile(item) {
      item.user_mobile.push("");
    },
    //删除中奖人手机号
    del_user_mobile(item, i) {
      if (i === 0) return this.$message("至少保留一个");
      item.user_mobile.splice(i, 1);
    },
    //优惠券
    async getcouponList() {
      let data = {
        app_id: store.getters.app_id,
        is_exp: 0
      };
      const res = await couponList(data);
      if (res.code == 200) {
        res.data.result.forEach(item => {
          item.coupon_num = 1;
          item.coupon_id = item.id;
        });
        this.options = this.options.concat(res.data.result);
      }
    },
    //图片上传
    imgUpload(file, item) {
      var formdata = new FormData();
      formdata.append("image", file.file);
      formdata.append("type", "1");
      formdata.append("file_group", "1");
      addImage(formdata).then(res => {
        console.log("上传回调", res);
        if (res.code == 200) {
          item.pic_url = res.data.url;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    Remaining_method(val, i) {
      console.log("999", val);
      let sum = 0;
      let sums = 0;
      this.Remainings[i] = Number(val);
      this.Remainings.forEach((item, i) => {
        sum += item;
      });
      sums = 100 - sum;
      if (sums > 100 || sums < 0) {
        this.$message.error("不可超过100%或者小于0");
      } else {
        this.Remaining = Math.round(sums * 100) / 100;
      }
    },

    coupons_select(val, item) {
      //选择优惠券
      item.coupon_list = myFilter(this.options, val);
      console.log(val);
    },
    del_coupon(val, item) {
      //删除选中的优惠券
      item.coupon_list = myFilter(this.options, val);
    },
    getItem(i, img) {
      this.activeClass = i;
      this.img = img;
    },
    back() {
      this.$emit("active", 1);
    },
    prize_type_method(val, item) {
      console.log(val);
      switch (val) {
        case 1:
          item.pic_url =
            "https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1621329558.png";
          break;
        case 2:
          item.pic_url =
            "https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1621329814.jpeg";
          break;
        case 4:
          item.pic_url =
            "https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1621330010.jpeg";
          break;
        case 5:
          item.pic_url =
            "https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1621330453.jpeg";
          break;
        default:
          item.pic_url = "";
          break;
      }
    },

    async onSubmit() {
      try {
        let key = true;
        let rates = 0;
        let rate_arrs = [];
        let length = true;
        let award_typeArrs = [];
        let obj = this.form.awards.find(item => {
          return item.award_type == 5;
        });
        this.form.awards.forEach((item, i) => {
          if (item.award_type == 5) {
            award_typeArrs.push(item);
          }

          rate_arrs.push(item.rate);
          if (
            item.award_name === "" ||
            item.pic_url === "" ||
            item.award_type === "" ||
            item.rate === "" ||
            item.stock === ""
          ) {
            key = false;
          }
          switch (item.award_type) {
            case 1:
              if (item.coupon_list.length == 0) {
                key = false;
              }
              break;
            case 2:
              if (item.integral == "") {
                key = false;
              }
              break;
            case 3:
              if (item.pic_url == "") {
                key = false;
              }
              break;
            case 4:
              if (item.balance == "") {
                key = false;
              }
              break;
            default:
              break;
          }

          if (item.award_name.length > 5) {
            length = false;
          }
        });
        if (award_typeArrs.length == 0) {
          return this.$message.error("请确保必须存在一个谢谢参与!!!");
        }
        for (let i = 0; i < rate_arrs.length; i++) {
          rates += Number(rate_arrs[i]);
        }

        if (rates !== 100) {
          this.$message.error("请确保概率相加等于100%");
          return false;
        }
        if (!length) {
          this.$message("请检查奖品名称不能超过五个汉字!!!");
          return false;
        }
        if (!key) {
          this.$message("请确保奖品信息填写完整!!!");
          return false;
        }
        showLoading();
        this.form.app_id = store.getters.app_id;

        this.form.is_consume = this.form.is_consume ? 1 : 0;

        this.form.is_free = this.form.is_free ? 1 : 0;

        this.form.is_consume_card_recharge = this.form.is_consume_card_recharge
          ? 1
          : 0;

        this.form.is_consume_card_consume = this.form.is_consume_card_consume
          ? 1
          : 0;

        this.form.is_integral = this.form.is_integral ? 1 : 0;
        this.form.is_display = this.form.is_display ? 1 : 0;

        this.form.awards.forEach((e, i) => {
          if (e.coupon_list) {
            e.coupon_list.forEach((item, idx) => {
              Object.keys(item).map(items => {
                switch (items) {
                  case "coupon_id":
                    break;
                  case "coupon_num":
                    break;
                  default:
                    this.$delete(item, items);
                    break;
                }
              });
            });
          } else {
            e.coupon_list = [
              {
                coupon_id: "",
                coupon_num: ""
              }
            ];
          }

          Object.keys(e).map(es => {
            switch (es) {
              case "coupons":
                this.$delete(e, es);
                break;
              case "id":
                this.$delete(e, es);
                break;
              case "label":
                this.$delete(e, es);
                break;
              default:
                break;
            }
          });
        });

        if (
          this.form.consume_products &&
          this.form.consume_products.length > 0
        ) {
          this.form.consume_products.forEach((item, i) => {
            if (item.goods_ids.length > 0) {
              console.log(typeof item.goods_ids);
              item.goods_ids = item.goods_ids.join(",");
            }
          });
        }

        if (
          this.form.consume_card_recharge_cards &&
          this.form.consume_card_recharge_cards.length > 0
        ) {
          this.form.consume_card_recharge_cards.forEach((item, i) => {
            if (item.goods_ids.length > 0) {
              item.goods_ids = item.goods_ids.join(",");
            }
          });
        }

        if (
          this.form.consume_card_consume_cards &&
          this.form.consume_card_consume_cards.length > 0
        ) {
          this.form.consume_card_consume_cards.forEach((item, i) => {
            if (item.goods_ids.length > 0) {
              item.goods_ids = item.goods_ids.join(",");
            }
          });
        }

        if (this.form.population_member_ids.length > 0) {
          this.form.population_member_ids = this.form.population_member_ids.join(
            ","
          );
        } else {
          this.form.population_member_ids = String(
            this.form.population_member_ids
          );
        }

        if (this.form.population_level_ids.length > 0) {
          this.form.population_level_ids = this.form.population_level_ids.join(
            ","
          );
        } else {
          this.form.population_level_ids = String(
            this.form.population_level_ids
          );
        }

        if (this.form.population_tag_ids.length > 0) {
          this.form.population_tag_ids = this.form.population_tag_ids.join(",");
        } else {
          this.form.population_tag_ids = String(this.form.population_tag_ids);
        }

        if (this.form.awards.length > 0) {
          this.form.awards.forEach((item, i) => {
            if (typeof item.user_mobile == "object") {
              item.user_mobile = item.user_mobile.join(",");
            }
            item.user_time = item.user_time
              ? time.Time_stamp(item.user_time)
              : 0;
            item.rate = Number(Number(item.rate) * 100);
          });
        }

        if (this.$route.query.key == 1) {
          const edit = await lottery_edit(this.form);
          if (edit.code === 200) {
            this.$message.success(edit.msg);
            this.$emit("active", 3);
            hideLoading();
          } else {
            this.$message.error(edit.msg);
            hideLoading();
          }
        } else {
          const res = await luck_draw(this.form);

          if (res.code === 200) {
            this.$emit("active", 3);
            hideLoading();
          } else {
            this.$message.error(res.msg);
            hideLoading();
            this.public(this.form.awards.length);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    public(val, type) {
      let arrs = ["", "一", "二", "三", "四", "五", "六", "七", "八"];

      if (this.$route.query.key) {
        if (type == "edit") {
          let arr = [];
          console.log(val);

          for (let i = 1; i <= val; i++) {
            arr.push({
              id: i,
              label: "奖品" + arrs[i],
              award_type: 1,
              award_name: "",
              integral: "",
              coupon_list: [],
              balance: "",
              rate: "",
              stock: "",
              user_mobile: [""],
              user_num: "",
              user_time: "",
              isShow: false,
              pic_url:
                "https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1621329558.png"
            });
          }

          store.getters.lotteryfrom.awards = store.getters.lotteryfrom.awards.concat(
            arr
          );

          store.getters.lotteryfrom.awards.forEach((item, i) => {
            item.label = "奖品" + arrs[i + 1];
          });
        } else {
          let num = 0;
          this.form.awards.forEach((item, i) => {
            this.Remainings.forEach((e, idx) => {
              if (item.rate) {
                e = item.rate;
              } else {
                e = 0;
              }
            });
            item.id = i + 1;
            item.label = "奖品" + arrs[i + 1];
            num += item.rate;
            if (item.user_mobile != "") {
              this.form.awards[i].isShow = true;
            }
            if (typeof item.user_mobile == "string") {
              item.user_mobile =
                item.user_mobile != "" ? item.user_mobile.split(",") : [""];
            }

            console.log("手机", item.user_mobile);
            item.coupons = [];

            if (item.coupon_list.length > 0) {
              item.coupon_list.forEach((e, idx) => {
                item.coupons.push(Number(e.coupon_id));
                console.log(e);
                e.title = e.coupon_title;
              });
            }
          });
          this.Remaining = this.Remaining - num;
        }
      } else {
        let arr = [];
        console.log(val);
        for (let i = 1; i <= val; i++) {
          arr.push({
            id: i,
            label: "奖品" + arrs[i],
            award_type: 1,
            award_name: "",
            integral: "",
            coupon_list: [],
            balance: "",
            rate: "",
            stock: "",
            user_mobile: [""],
            user_num: "",
            user_time: "",
            isShow: false,
            pic_url:
              "https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1621329558.png"
          });
        }
        store.getters.lotteryfrom.awards = store.getters.lotteryfrom.awards.concat(
          arr
        );
        store.getters.lotteryfrom.awards.forEach((item, i) => {
          item.label = "奖品" + arrs[i + 1];
        });
      }
      this.form = store.getters.lotteryfrom;
    }
  }
};
</script>
<style lang="scss" scoped>
.conten {
  width: 95%;
  // height: 40vw;
  background-color: #ffffff;
  margin: 20px auto;
  padding: 20px 0;
  // line-height: 5vw;
}

.el-divider {
  margin: 10px 0 !important;
  margin-bottom: 30px !important;
}

.fengmian {
  padding-top: 15px;

  img {
    width: 70px;
    height: 100px;
    margin-right: 10px;
  }

  .active {
    /* background: #eee; */
    // color: #1e82d2;
    box-shadow: #1e82d2 0px 0px 8px;
    // font-weight: bolder;
  }
}

.Preview {
  width: 95%;
  height: 33vw;
  margin: 20px auto;
  background-color: #f8f8f8f8;
  padding: 30px 20px;
  box-sizing: border-box;

  .Preview_top {
    width: 90%;
    height: 2vw;
    background-color: #ffffff;
    text-align: center;
    line-height: 2vw;
  }

  .Preview_img {
    width: 90%;
    height: 28vw;
    position: relative;
    // background-color: #ffffff;
    // text-align: center;
    // line-height: 2vw;
    .Preview_img_text {
      width: 100%;
      height: 1.5vw;
      // background-color: #000;
      line-height: 1.6vw;
      color: #fff;
      text-align: center;
      position: absolute;
      top: 3.7vw;
      z-index: 100;
    }

    img {
      width: 100%;
      height: 100%;
      // cursor:pointer;
    }
  }
}

.content_s {
  width: 60%;
  background-color: #f8f8f8;
  padding: 1vw;
  margin-left: 10px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 100%;
  line-height: 100%;
  text-align: center;
}

.avatar {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
